import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

const activitiesDisplay: Record<string, string> = displayValues.amenities.activities;

export const ActivityFilter = () => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const facetList = useSelector((s: PaleState) => s.results.facets.activities);
    const checkboxValues = useSelector((s: PaleState) => s.filters.activities);

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxActivity(valueOrMap));
    };

    const fetchResultsProxy: CheckboxDispatchProps['fetchResults'] = (queryParams) => {
        dispatch(fetchResults(queryParams));
    };

    const hasOptions = useMemo(() => Array.isArray(facetList) && facetList.some((f) => Boolean(activitiesDisplay[f.value])), [facetList]);

    return hasOptions ? (
        <CheckboxFilter
            id="activityFilter"
            label="Aktiviteter"
            facetList={facetList}
            displayValues={activitiesDisplay}
            checkboxValues={checkboxValues}
            checkBoxClick={checkBoxClick}
            fetchResults={fetchResultsProxy}
        />
    ) : null;
};
